var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJivo = function SvgJivo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4898_9919)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 1,
    y: 1,
    fill: "white",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M17 22V23H7V22H17ZM22 17V7C22 4.23858 19.7614 2 17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22V23L6.69141 22.9922C3.52111 22.8316 1 20.2102 1 17V7C1 3.68629 3.68629 1 7 1H17C20.3137 1 23 3.68629 23 7V17C23 20.3137 20.3137 23 17 23V22C19.7614 22 22 19.7614 22 17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393646",
    d: "M13.2669 9.19912C13.2669 9.19912 10.4086 9.19495 10.3752 9.19912C10.1776 9.19495 9.98555 9.39394 10.0009 9.59989C10.0009 9.62911 9.99947 10.709 10.0009 10.7563C10.0162 10.9483 10.2082 11.132 10.4002 11.132H11.7334V17.8644C11.7334 18.5309 11.2004 19.0639 10.5338 19.0639C10.2625 19.018 9.99668 19.2267 10.0009 19.4647C10.0009 19.4939 9.99947 20.5738 10.0009 20.6211C10.0189 20.8409 10.2486 21.0246 10.467 20.9968C12.1995 20.9968 13.6662 19.5969 13.6662 17.8644C13.6662 17.792 13.6662 9.67364 13.6662 9.5985C13.6662 9.33132 13.4659 9.19912 13.2669 9.19912Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15BE60",
    d: "M10.1347 3C9.93429 7.39873 13.4675 7.99989 13.4675 7.99989C13.2671 3.20038 10.1347 3 10.1347 3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4898_9919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export default SvgJivo;